import { render } from "./EnImitateUserDialog.vue?vue&type=template&id=0980b782"
import script from "./EnImitateUserDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EnImitateUserDialog.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/modals/EnImitateUserDialog/EnImitateUserDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0980b782"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0980b782', __exports__)) {
    api.reload('0980b782', __exports__)
  }
  
  module.hot.accept("./EnImitateUserDialog.vue?vue&type=template&id=0980b782", () => {
    api.rerender('0980b782', render)
  })

}


export default __exports__